import { Component, ElementRef, Inject, Input, OnInit, Optional, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
const secretKey = environment.uadSecret
@Component({
  selector: 'app-authenticator',
  templateUrl: './authenticator.component.html',
  styleUrls: ['./authenticator.component.scss']
})
export class AuthenticatorComponent implements OnInit {
  otpForm!: FormGroup;
  submitted = false;
  otp: string = '';
  @Input() barcodeImageUrl: any;
  @Input() isGoogleAuthenticatorRegistered: any;
  @Input() getuserAuthentication: any;
  @Input() authenticationUniqueCode: any;
  @Input() otpPromptMessage: any;
  @Input() otpValue: string = '';
  showResend: boolean = false;
  interval: any;
  timeRemaining_percent!: number;
  @ViewChild('otpInput') otpInput!: ElementRef;
  isGoogleAuthenticatorIsSetToPrimaryOrSelected: boolean = false;
  currentLoginAuthenticationSelected: any = {};
  resendCountdown: number = 60;
  timer!: number;
  remainingTime!: any;
  intervalId: any;
  constructor(private fb: FormBuilder,
    private loader: LoaderService,
    public router: Router,
    private restService: RestService,
    private translate: TranslateService,
    private authService: AuthService,
    private renderer: Renderer2,
    private cookieService: CookieService,
    private commonService: CommonService,
    @Optional() private dialogRef: MatDialogRef<AuthenticatorComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    const otpMessage = document.getElementById('otp-message');
    setTimeout(() => {
      if (otpMessage)
        otpMessage.style.display = 'none';
    }, 20000);

    this.currentLoginAuthenticationSelected = this.getuserAuthentication.find((auth: any) => auth.isPrimary);
    this.isGoogleAuthenticatorIsSetToPrimaryOrSelected = this.currentLoginAuthenticationSelected.mfaAuthenticationTypeID == 1030;

    if (!this.isGoogleAuthenticatorIsSetToPrimaryOrSelected) {
      this.startTimer();
    }

    this.setFocusOnOTPInput();
    this.otpForm = this.fb.group({
      otp: [this.otpValue, [Validators.required]]
    })
    for (let i = 0; i < 6; i++) {
      this.otpForm.addControl('otp' + i, new FormControl('', Validators.required))
    }
    const redirectUrl = this.cookieService.get('redirect_url');
    if(!redirectUrl.includes('csr')){
      setTimeout(() => {
        this.patchOtpValue(this.otpValue);
      }, 100)
    }
    this.otpForm.valueChanges.subscribe(value => {
      this.submitted = false;
    })
  }
  patchOtpValue(otpValue: string) {
    const otpValueStr = otpValue.toString();
    for (let i = 0; i < otpValueStr.length; i++) {
      const controlName = 'otp' + i;
      if (this.otpForm.get(controlName)) {
        this.otpForm.get(controlName).setValue(otpValueStr[i]);
      } else {
        console.error(`Control ${controlName} not found`); // Log an error if control not found
      }
    }
  }
  startTimer() {
    this.stopCountdownTimer();
    this.resendCountdown = 60;
    this.timer = this.resendCountdown;
    this.remainingTime = this.timer;
    this.timeRemaining_percent = (this.remainingTime / this.timer) * 100
    this.intervalId = setInterval(() => {
      this.remainingTime--;
      this.timeRemaining_percent = (this.remainingTime / this.timer) * 100
      if (this.remainingTime <= 0) {
        this.stopCountdownTimer();
        this.showResend = true;
      }
    }, 1000);

  }

  stopCountdownTimer() {
    clearInterval(this.intervalId);
  }

  setFocusOnOTPInput() {
    setTimeout(() => {
      if (this.otpInput?.nativeElement) {
        this.renderer.selectRootElement(this.otpInput.nativeElement).focus();
      }
    }, 100);
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  get control() {
    return this.otpForm.controls;
  }

  otpVerify() {
    this.getOtp();
    this.submitted = true;
    if (this.otpForm.invalid) {
      return;
    }

    if (this.isGoogleAuthenticatorIsSetToPrimaryOrSelected) {
      this.validateGoogleAuthOTP();
    } else {
      this.validateMFAOTP();
    }
  }

  validateMFAOTP() {
    let params = {
      authenticationUniqueCode: this.authenticationUniqueCode,
      MFAAuthenticationTypeID: this.currentLoginAuthenticationSelected.mfaAuthenticationTypeID,
      OTP: this.otpForm.get('otp')?.value
    }

    this.loader.show();
    this.restService.postUATData(params, 'api/digital/core/Account/ValidateMFAOTP').subscribe({
      next: (data: any) => {
        this.loader.hide();
        if (data.rcode == 200) {
          this.authService.saveRefreshToken(data.rObj.refreshToken);
          this.authService.b2cAttemptAuth(data.rObj.token);
          const encryptedValue = CryptoJS.AES.encrypt(data.rObj.token, secretKey).toString();
          const encryptedRValue = CryptoJS.AES.encrypt(data.rObj.refreshToken, 'refresh_token').toString();
          const domain = '.insure.digital'; // Set for root domain
          const domain1 = '.swiftant.com'; // Set for root domain

          this.cookieService.set('JWTtoken', encryptedValue, null, '/', domain, false, 'Strict');
          this.cookieService.set('JWTtoken', encryptedValue, null, '/', domain1, false, 'Strict');
          this.cookieService.set('JWTtoken', encryptedValue, null, '/', 'localhost', false, 'Strict');
          this.cookieService.set('RefreshToken', encryptedRValue, null, '/', domain, false, 'Strict');
          this.cookieService.set('RefreshToken', encryptedRValue, null, '/', domain1, false, 'Strict');
          this.cookieService.set('RefreshToken', encryptedRValue, null, '/', 'localhost', false, 'Strict');
          const redirectUrl = this.cookieService.get('redirect_url');
          const orgAppId = this.cookieService.get('orgAppId');
          if (redirectUrl && orgAppId) {
            // Construct the URL with the parameters from cookies
            const decodedUrl = decodeURIComponent(redirectUrl);
            window.location.href = decodedUrl; // Redirect to the decoded URL
            // Navigate to the constructed URL
            this.router.navigateByUrl(decodedUrl);
          }
        }
      },
      error: (error: any) => {
        this.loader.hide();
        let errorCode = error.error.rmsg[0].errorCode ?? 'ERROR'
        this.commonService.apiErrorMessageDialog(error.error.trnID, errorCode);
      }
    });
  }

  validateGoogleAuthOTP() {
    let params = {
      authenticationUniqueCode: this.authenticationUniqueCode,
      OTP: this.otpForm.get('otp')?.value
    }

    this.loader.show();
    this.restService.postUATData(params, 'api/digital/core/Account/ValidateGoogleAuthOTP').subscribe({
      next: (data: any) => {
        this.loader.hide();
        if (data.rcode == 200) {
          this.authService.saveRefreshToken(data.rObj.refreshToken);
          this.authService.b2cAttemptAuth(data.rObj.token);
          const encryptedValue = CryptoJS.AES.encrypt(data.rObj.token, secretKey).toString();
          const encryptedRValue = CryptoJS.AES.encrypt(data.rObj.refreshToken, 'refresh_token').toString();
          const domain = '.insure.digital'; // Set for root domain
          const domain1 = '.swiftant.com'; // Set for root domain

          this.cookieService.set('JWTtoken', encryptedValue, null, '/', domain, false, 'Strict');
          this.cookieService.set('JWTtoken', encryptedValue, null, '/', domain1, false, 'Strict');
          this.cookieService.set('JWTtoken', encryptedValue, null, '/', 'localhost', false, 'Strict');
          this.cookieService.set('RefreshToken', encryptedRValue, null, '/', domain, false, 'Strict');
          this.cookieService.set('RefreshToken', encryptedRValue, null, '/', domain1, false, 'Strict');
          this.cookieService.set('RefreshToken', encryptedRValue, null, '/', 'localhost', false, 'Strict');
          const redirectUrl = this.cookieService.get('redirect_url');
          const orgAppId = this.cookieService.get('orgAppId');
          if (redirectUrl && orgAppId) {
            // Construct the URL with the parameters from cookies
            const decodedUrl = decodeURIComponent(redirectUrl);
            window.location.href = decodedUrl; // Redirect to the decoded URL
            // Navigate to the constructed URL
            this.router.navigateByUrl(decodedUrl);
          }
        }
      },
      error: (error: any) => {
        this.loader.hide();
        let errorCode = error.error.rmsg[0].errorCode ?? 'ERROR'
        this.commonService.apiErrorMessageDialog(error.error.trnID, errorCode);
      }
    });
  }

  onInputChange(event: Event, forWhat: string) {
    this.otpForm.controls[forWhat].setValue((event.target as HTMLInputElement).value.replace(/\D/g, ''));
  }


  onOtpInput(index: number) {
    const nextIndex = index + 1;
    this.otp = this.otp + this.otpForm.controls['otp' + index].value;
    if (nextIndex < 6 && this.otpForm.controls['otp' + index].value) {
      const input = <HTMLInputElement>document.getElementById('otp' + nextIndex);
      input.focus();
    }
  }

  numberOnly(event: any, index: number) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  changeAuthenticationType(authenticationDetails: any) {
    this.currentLoginAuthenticationSelected = authenticationDetails;
    this.pauseTimer();
    if (authenticationDetails.mfaAuthenticationTypeID == 1030) {
      // this.pauseTimer();
      this.isGoogleAuthenticatorIsSetToPrimaryOrSelected = true;
    } else {
      // this.pauseTimer();
      this.startTimer();
      this.isGoogleAuthenticatorIsSetToPrimaryOrSelected = false;
    }
    for (let i = 0; i < 6; i++) {
      this.otpForm.controls['otp' + i].setValue('')
    }
    this.sendMFAOTP(authenticationDetails);
    this.setFocusOnOTPInput();
  }

  onBackspaceKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      event.preventDefault();
      if (index >= 0) {
        this.otpForm.controls['otp' + index].setValue(''); // Delete the previous item in the OTP array
        if (index > 0) {
          this.otpForm.controls['otp' + (index - 1)].setValue('');
        }
        const previousInputId = 'otp' + (index - 1);
        const previousInputElement = document.getElementById(previousInputId) as HTMLInputElement;
        if (previousInputElement) {
          previousInputElement.focus(); // Focus the previous input box
        }
      }
    }
  }

  getOtp() {
    let otp = '';
    for (let i = 0; i < 6; i++) {
      otp += this.otpForm.controls['otp' + i].value;
    }
    this.otpForm.controls['otp'].setValue(otp);
  }

  goBack() {
    this.submitted = false;
    for (let i = 0; i < 6; i++) {
      this.otpForm.controls['otp' + i].setValue('')
    }
    window.location.reload();
  }

  resendOtp() {
    this.sendMFAOTP(this.currentLoginAuthenticationSelected);
  }

  sendMFAOTP(authenticationDetails: any) {
    let params = {
      authenticationUniqueCode: this.authenticationUniqueCode,
      mfaAuthenticationTypeID: authenticationDetails.mfaAuthenticationTypeID
    }
    this.loader.show();
    this.restService.postUATData(params, 'api/digital/core/Account/SendMFAOTP').subscribe({
      next: (data: any) => {
        this.loader.hide();
        if (data.rcode == 200) {
          this.setFocusOnOTPInput();
          this.showResend = false;
          this.startTimer();
          this.otpPromptMessage = data.rObj.message
        }
      },
      error: (error: any) => {
        this.loader.hide();
        let errorCode = error.error.rmsg[0].errorCode ?? 'ERROR'
        this.commonService.apiErrorMessageDialog(error.error.trnID, errorCode);
      }
    })

  }
}
